export const UPDATE_SOLUTION_INSTANCE_SCHEDULE = 'workflowExecution/updateSolutionInstanceSchedule';
